import React from 'react'
import PropTypes from 'prop-types'
import { formatDateTime } from '../../../../util/datetime'
import ContentBox from '../../../layout/component/ContentBox'
import currentUserHasAccess from '../../../../util/widget-helper'
import { SALES_ORDER_STATUS_HISTORY } from '../../ui-definition/sales-order-ui'

const StatusRow = ({ statusHistoryItem }) => {
    return (
        <tr key={statusHistoryItem.id}>
            <td>{formatDateTime(statusHistoryItem.changed)}</td>
            <td>{statusHistoryItem.statusName}</td>
            <td>{statusHistoryItem.changedByEmployeeName}</td>
        </tr>
    )
}

StatusRow.propTypes = {
    statusHistory: PropTypes.object,
    employeeName: PropTypes.string,
    statusName: PropTypes.string,
    type: PropTypes.string,
}


const StatusHistory = ({ statusHistory }) => {
    if (!currentUserHasAccess(SALES_ORDER_STATUS_HISTORY)) {
        return null
    }

    return (
        <ContentBox title="Status history">
            <table className="default-table">
                <thead>
                    <tr>
                        <th>changed</th>
                        <th>new status</th>
                        <th>changed by</th>
                    </tr>
                </thead>
                <tbody>
                    {statusHistory.map(statusHistoryItem => {
                        return <StatusRow key={statusHistoryItem.id} statusHistoryItem={statusHistoryItem}/>
                    })}
                </tbody>
            </table>
        </ContentBox>
    )
}


StatusHistory.propTypes = {
    statusHistory: PropTypes.array.isRequired,
}

export default StatusHistory



// WEBPACK FOOTER //
// ./src/modules/sales-order/component/detail/StatusHistory.js